import { registerCustomDetailComponent } from '@bb-vendure/admin-ui/core';
import { ProductStatisticComponent } from './components/ProductStatistic/product-statistic.component';

export default [
    // registerCustomDetailComponent({
    //     locationId: 'product-detail',
    //     component: ProductStatisticComponent,
    // }),
    
];